import { ThemeTailwindType } from 'src/domains/common/themeColors';
import { akbetsColors } from 'src/domains/common/universes/akbets/akbets.config';
import { betwrightColors } from 'src/domains/common/universes/betwright/betwright.config';
import { bresbetColors } from 'src/domains/common/universes/bresbet/bresbet.config';
import { betStGeorgeColors } from 'src/domains/common/universes/betstgeorge/betstgeorge.config';
import { dragonbetColors } from 'src/domains/common/universes/dragonbet/dragonbet.config';
import { energyColors } from 'src/domains/common/universes/energy/energy.config';
import { gentlemanjimColors } from 'src/domains/common/universes/gentlemanjim/gentlemanjim.config';
import { mcbookieColors } from 'src/domains/common/universes/mcbookie/mcbookie.config';
import { planetsportbetColors } from 'src/domains/common/universes/planetsportbet/planetsportbet.config';
import { pricedupColors } from 'src/domains/common/universes/pricedup/pricedup.config';
import { starColors } from 'src/domains/common/universes/star/star.config';
import { UniverseType } from 'src_common/common/universe';
import { bestoddsColors } from 'src/domains/common/universes/bestodds/bestodds.config';
import { londonbetColors } from 'src/domains/common/universes/londonbet/londonbet.config';
import { properbetColors } from 'src/domains/common/universes/properbet/properbet.config';

const universeColorsMap: Record<UniverseType, ThemeTailwindType> = {
    akbets: akbetsColors,
    bestodds: bestoddsColors,
    betwright: betwrightColors,
    bresbet: bresbetColors,
    dragonbet: dragonbetColors,
    energy: energyColors,
    gentlemanjim: gentlemanjimColors,
    londonbet: londonbetColors,
    mcbookie: mcbookieColors,
    planetsportbet: planetsportbetColors,
    pricedup: pricedupColors,
    star: starColors,
    betstgeorge: betStGeorgeColors,
    properbet: properbetColors,
};

export const setTheme = (themeUniverse: UniverseType): void => {
    const theme = universeColorsMap[themeUniverse];

    Object.entries(theme).forEach(([key, value]) => {
        document.documentElement.style.setProperty(key, value);
    });
};
